import { WebserviceResponse } from "../interfaces";

export function normalizeSingletonResponse<T>(response: WebserviceResponse<T>): WebserviceResponse<T> {
  const rawObject = (response as any)?.object;
  const object = (Array.isArray(rawObject)
    ? rawObject
    : rawObject != null
      ? [rawObject]
      : []) as WebserviceResponse<T>["object"];

  return {
    ...response,
    object
  };
}
